// Lo que el catálogo en caché sabe de cada SKU y la línea apartada no trae: servicio y nombre visible.
import { useMemo } from 'react';
import { descriptionsBySku, serviceSkusOf } from '../cartLines';
import { useCatalog } from './useWizard';

export interface CatalogLineInfo {
    serviceSkus: ReadonlySet<string>;
    descriptions: ReadonlyMap<string, string>;
}

/** Vacío mientras el catálogo no responde: las líneas caen a su categoría y a marca, modelo o SKU. */
export function useCatalogLineInfo(sessionId: string): CatalogLineInfo {
    const items = useCatalog(sessionId, { cached: true }).data?.items;
    return useMemo(
        () => ({
            serviceSkus: serviceSkusOf(items ?? []),
            descriptions: descriptionsBySku(items ?? []),
        }),
        [items],
    );
}
